var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c("NewComments", {
        attrs: { messageType: _vm.messageType, siteId: _vm.siteId },
      }),
      _c(
        "div",
        { staticClass: "wl-content-container content-with-comments" },
        [
          _c("div", { staticClass: "tab-box" }, [
            _c("ul", { staticClass: "wl-tab" }, [
              _vm.getSite.hasInterim
                ? _c(
                    "li",
                    {
                      class: _vm.active === "1" ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.handleClick("1")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("COMMON_INTERIM")) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "li",
                {
                  class: _vm.active === "2" ? "active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.handleClick("2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("COMMON_FINAL")))]
              ),
            ]),
            _c(
              "div",
              { staticClass: "top-right-btns" },
              [
                _c(
                  "div",
                  {
                    class:
                      _vm.updateGuide && _vm.updateGuideStep === 2
                        ? "updateGuideIcon"
                        : "",
                  },
                  [
                    _c("GuidanceTooltip", {
                      staticClass: "downloadpbc-tip",
                      attrs: {
                        content: _vm.topTipContent(),
                        size: 20,
                        iconSize: 15,
                        jumpLink: _vm.$t(
                          `downloadPBCTip_${_vm.getUser.userType}`
                        ),
                      },
                    }),
                    _vm.updateGuide && _vm.updateGuideStep === 2
                      ? _c(
                          "div",
                          { staticClass: "updateGuideTip" },
                          [
                            _c("div", { staticClass: "margin-bottom-10" }, [
                              _vm._v("2/2"),
                            ]),
                            _c("div", { staticClass: "margin-bottom-10" }, [
                              _vm._v(_vm._s(_vm.$t("guidanceTip"))),
                            ]),
                            _c(
                              "el-button",
                              {
                                staticClass: "guide-btn",
                                on: { click: _vm.gotItClick },
                              },
                              [_vm._v(_vm._s(_vm.$t("gotIt")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "split" }),
                _c(
                  "TableColumnsControl",
                  {
                    staticClass: "table-column-config",
                    attrs: {
                      tableName: "pbc",
                      onColumnsLoad: _vm.onColumnsLoad,
                      anyHidden: _vm.anyHidden,
                    },
                    on: {
                      "update:anyHidden": function ($event) {
                        _vm.anyHidden = $event
                      },
                      "update:any-hidden": function ($event) {
                        _vm.anyHidden = $event
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "column-btn",
                          _vm.anyHidden ? "column-btn-active" : "",
                        ],
                      },
                      [
                        _c("img", {
                          staticClass: "table-setting-icon",
                          attrs: {
                            src: require("@/assets/img/icon-table-setting.svg"),
                            width: "100%",
                          },
                        }),
                        _c("span", { staticClass: "table-setting-text" }, [
                          _vm._v(_vm._s(_vm.$t("table_columns_display_btn"))),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "split" }),
                _c(
                  "div",
                  {
                    class: [
                      "clean-filter",
                      _vm.clearAllActive ? "clean-filter-active" : "",
                    ],
                    on: { click: _vm.clearAll },
                  },
                  [
                    _c("img", {
                      staticClass: "table-setting-icon",
                      attrs: { src: require("@/assets/img/icon-screen.svg") },
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("clear_filter")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-row",
            { staticClass: "search-btn-row" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: {
                    disabled:
                      _vm.tableStatus.editable ||
                      !_vm.hasPermission("download"),
                    icon: "el-icon-download",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onToogleDownLoad("download")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("BATCH_DOWNLOAD")))]
              ),
              _vm.getUser.userType == "1"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      staticStyle: { position: "relative", top: "2PX" },
                      attrs: { disabled: _vm.tableStatus.editable },
                      on: { click: _vm.onToogleStatus },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-batchsetting.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("COMMON_SET_STATUS")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "wl-green right",
                  attrs: {
                    disabled:
                      _vm.tableStatus.editable ||
                      !_vm.hasPermission("download"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onToogleDownLoad("export")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/img/icon-export.svg"),
                      width: "100%",
                    },
                  }),
                  _vm._v(_vm._s(_vm.$t("BATCH_export"))),
                ]
              ),
              _vm.getUser.userType == "1"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green right",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: { click: _vm.exportTableList },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(_vm._s(_vm.$t("Export_PBC_Items"))),
                    ]
                  )
                : _vm._e(),
              _vm.getUser.userType == "2"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green right",
                      on: { click: _vm.clientExportTableList },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(_vm._s(_vm.$t("Export_PBC_Items"))),
                    ]
                  )
                : _vm._e(),
              _vm.getUser.userType == "1"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green right",
                      attrs: {
                        disabled: _vm.tableStatus.editable,
                        icon: "el-icon-message",
                      },
                      on: { click: _vm.onToogleSendEmail },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("PAGE_CLIENTUSER_EMAIL_PBC")) +
                          "\n                "
                      ),
                      _c("GuidanceTooltip", {
                        attrs: {
                          content: _vm.$t("sendNotifyEmailTipHtml"),
                          backgroundColor: "none",
                          yellowIcon: "",
                          size: 20,
                          iconSize: 14,
                          jumpLink: _vm.$t("sendNotifyEmailLink"),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.active == "2" &&
              _vm.getSite.hasInterim &&
              _vm.getUser.userType == "1"
                ? _c(
                    "el-button",
                    {
                      staticClass: "wl-green right",
                      attrs: { disabled: _vm.tableStatus.editable },
                      on: { click: _vm.onToogleCopy },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-batchsetting.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(_vm._s(_vm.$t("COMMON_COPY_INTERIM"))),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "bottom" },
                },
                [
                  _c("div", {
                    staticStyle: { width: "500px" },
                    attrs: { slot: "content" },
                    domProps: { innerHTML: _vm._s(_vm.$t("PBC_LIST_TIPS")) },
                    slot: "content",
                  }),
                  _c(
                    "span",
                    { staticClass: "right" },
                    [
                      _vm.getUser.userType == "1"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "wl-green margin",
                              attrs: {
                                disabled: !(
                                  _vm.kpRoleBind && _vm.kpRoleBind.length > 0
                                ),
                              },
                              on: { click: _vm.goTo },
                            },
                            [
                              _c("img", {
                                staticClass: "btn-icon",
                                attrs: {
                                  src: require("@/assets/img/icon-batchsetting.svg"),
                                  width: "100%",
                                },
                              }),
                              _vm._v(_vm._s(_vm.$t("COMMON_PBC_LIST"))),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("pbc-table", {
            ref: "pbcTable",
            class: [
              "wl-pbc-table",
              _vm.showSearchParams
                ? _vm.screenWidth < 1920
                  ? "show-search-rows4"
                  : "show-search"
                : "",
            ],
            attrs: {
              loading: _vm.loading,
              downloading: _vm.fileDownloading,
              tableStatus: _vm.tableStatus,
              data: _vm.tableData,
              kpmgOwnerList: _vm.kpmgOwnerList,
              clientOwnerList: _vm.clientOwnerList,
              dataPBC: _vm.dataPBC,
              statusList: _vm.statusList,
              topicList: _vm.topicList,
              pagination: _vm.pagination,
              onCancel: _vm.btnCancel,
              onCancelInterim: _vm.updateTableStatusInterim,
              onChange: _vm.switchStatus,
              onPaginationChange: _vm.onPaginationChange,
              onChangeStatusPopShow: _vm.openChangeVisiblePop,
              onDownLoad: _vm.downloadPBC,
              onUploadFileAfter: _vm.getTableData,
              onCopy: _vm.copyFromInterim,
              sourceTypes: _vm.sourceTypes,
              onChangeRow: _vm.onChangeRow,
              downloadAble: _vm.downloadAble,
              curUserName: _vm.curUserName,
              siteId: _vm.siteId,
              showColumns: _vm.showColumns,
              serialNo: _vm.serialNo,
              topic: _vm.topic,
              topicDesList: _vm.topicDesList,
              topicDes: _vm.topicDes,
              createDate: _vm.createDate,
              dueTime: _vm.dueTime,
              sourceOfInfo: _vm.sourceOfInfo,
              filterStatusList: _vm.filterStatusList,
              status: _vm.status,
              dayOverDue: _vm.dayOverDue,
              daysUntilDue: _vm.daysUntilDue,
              uploadTime: _vm.uploadTime,
              periodEndDate: _vm.periodEndDate,
              commentDate: _vm.commentDate,
              fileName: _vm.fileName,
              clientResponsible: _vm.clientResponsible,
              kpmgResponsible: _vm.kpmgResponsible,
              updateGuide: _vm.updateGuide,
              updateGuideStep: _vm.updateGuideStep,
              lastedUploadUserAccount: _vm.lastedUploadUserAccount,
              screenWidth: _vm.screenWidth,
              clientConfirmDate: _vm.clientConfirmDate,
              messageType: _vm.messageType,
            },
            on: {
              selectKPOwner: _vm.selectKPOwner,
              selectClientOwner: _vm.selectClientOwner,
              "on-dueday-change": _vm.onDuedayChange,
              "on-charge-user-change": _vm.onChargeUserChange,
              "on-confirm-day-change": _vm.onConfirmDayChange,
              "update:serialNo": function ($event) {
                _vm.serialNo = $event
              },
              "update:serial-no": function ($event) {
                _vm.serialNo = $event
              },
              "update:topic": function ($event) {
                _vm.topic = $event
              },
              "update:topicDes": function ($event) {
                _vm.topicDes = $event
              },
              "update:topic-des": function ($event) {
                _vm.topicDes = $event
              },
              "update:createDate": function ($event) {
                _vm.createDate = $event
              },
              "update:create-date": function ($event) {
                _vm.createDate = $event
              },
              "update:dueTime": function ($event) {
                _vm.dueTime = $event
              },
              "update:due-time": function ($event) {
                _vm.dueTime = $event
              },
              "update:sourceOfInfo": function ($event) {
                _vm.sourceOfInfo = $event
              },
              "update:source-of-info": function ($event) {
                _vm.sourceOfInfo = $event
              },
              "update:status": function ($event) {
                _vm.status = $event
              },
              "update:dayOverDue": function ($event) {
                _vm.dayOverDue = $event
              },
              "update:day-over-due": function ($event) {
                _vm.dayOverDue = $event
              },
              "update:daysUntilDue": function ($event) {
                _vm.daysUntilDue = $event
              },
              "update:days-until-due": function ($event) {
                _vm.daysUntilDue = $event
              },
              "update:uploadTime": function ($event) {
                _vm.uploadTime = $event
              },
              "update:upload-time": function ($event) {
                _vm.uploadTime = $event
              },
              "update:periodEndDate": function ($event) {
                _vm.periodEndDate = $event
              },
              "update:period-end-date": function ($event) {
                _vm.periodEndDate = $event
              },
              "update:commentDate": function ($event) {
                _vm.commentDate = $event
              },
              "update:comment-date": function ($event) {
                _vm.commentDate = $event
              },
              "update:fileName": function ($event) {
                _vm.fileName = $event
              },
              "update:file-name": function ($event) {
                _vm.fileName = $event
              },
              "update:clientResponsible": function ($event) {
                _vm.clientResponsible = $event
              },
              "update:client-responsible": function ($event) {
                _vm.clientResponsible = $event
              },
              "update:kpmgResponsible": function ($event) {
                _vm.kpmgResponsible = $event
              },
              "update:kpmg-responsible": function ($event) {
                _vm.kpmgResponsible = $event
              },
              nextClick: _vm.nextClick,
              "update:lastedUploadUserAccount": function ($event) {
                _vm.lastedUploadUserAccount = $event
              },
              "update:lasted-upload-user-account": function ($event) {
                _vm.lastedUploadUserAccount = $event
              },
              "update:clientConfirmDate": function ($event) {
                _vm.clientConfirmDate = $event
              },
              "update:client-confirm-date": function ($event) {
                _vm.clientConfirmDate = $event
              },
            },
          }),
          _vm.batchUPdateVisible
            ? _c("batch-update", {
                attrs: {
                  onCancel: _vm.toogleBatchUPdateVisible,
                  chosenList: _vm.chosen,
                  statusList: _vm.statusList,
                  onBatchUpdate: _vm.batchUpdate,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("entity", {
        attrs: { onAdd: _vm.onDrawClick, entityData: _vm.entityData },
      }),
      _c("dashboard", {
        ref: "dashboard",
        attrs: {
          dashboardData: _vm.dashboardData,
          disabled: _vm.loading,
          dashboardLoading: _vm.dashboardLoading,
          dashboardTableLoading: _vm.dashboardTableLoading,
        },
        on: {
          getDashboardData: _vm.getDashboardData,
          chooseState: _vm.chooseState,
          chooseTab: _vm.getPbcDrawerTable,
        },
      }),
      _c("RsDashboard", {
        ref: "rsDashboard",
        attrs: {
          disabled: _vm.loading,
          rsDashboardLoading: _vm.rsDashboardLoading,
          data: _vm.rsDashboardData,
          dashboardTableLoading: _vm.dashboardTableLoading,
          chooseTabProp: _vm.getPbcDrawerTableData,
          makeLevel3Data: _vm.tableDataToLevel3,
          onCardClick: _vm.onRsDashboardCardClick,
        },
        on: {
          chooseTab: _vm.getPbcDrawerTable,
          getDashboardData: _vm.getDashboardData,
        },
      }),
      _vm._m(0),
      _c("file-confirm-modal", {
        ref: "FileConfirmModal",
        attrs: {
          fileDownloading: _vm.fileDownloading,
          groupList: _vm.selectedRow,
          downloadAble: _vm.downloadAble,
          curUserName: _vm.curUserName,
        },
        on: {
          ok: _vm.downloadMultipleFiles,
          fileDownload: _vm.downloadPBCListSingle,
          getPbcList: _vm.getTableData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "form",
      {
        staticStyle: { display: "none" },
        attrs: {
          id: "abc",
          method: "post",
          action: "/client/pbcGroup/downloadPbcFiles",
          onsubmit: "return false",
        },
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "id", value: "194226009606721540" },
        }),
        _c("input", {
          attrs: { type: "hidden", name: "fileName", value: "longhu.zip" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }